/** @deprecated Use CSS custom properties in src/styles/tokens.css instead */
export const BLUE = '#194483';
export const DARK_BLUE = '#1d3f59';
export const LIGHT_BLUE = '#59abe3';
export const GREEN = '#6fc381';
export const DARK_GREEN = '#5ea26d';
export const LIGHT_GRAY = '#f5f8fd';
export const SHADOW = '#0000002d';

const founders = {
  name: 'Founders',
  members: [
    'Dhruv Baid',
    'Shriya Bansal',
    'Elly Choi',
    'Cameron Lowry',
    'Vallary Muhalia',
    'Blaise Muhirwa',
    'Emma Rosenthal',
    'Elaine Wan',
  ],
};

const alpha = {
  name: 'Alpha',
  members: [
    'Abigail Barnes',
    'Lexington Brill',
    'Ellen Chen',
    'Elizabeth Coble',
    'Isabella DeClue',
    'Tessie Dong',
    'Chelsea Egbarin',
    'Pratham Gandhi',
    'Marie-Liesse Gouilliard',
    'Beatrice Katnelson',
    'Elise Katnelson',
    'Eric Liu',
    'Tudor Popescu',
    'Sam Shatzkin',
    'Vann Strasen',
    'Danya Wang',
    'Laura Zielinski',
  ],
};

const beta = {
  name: 'Beta',
  members: [
    'Amulya Agrawal',
    'Emilio Andere',
    'Don Assamongkol',
    'Jackson Brouwer',
    'Yoobin Cha',
    'Max Gallo',
    'Jaeyoung Kim',
    'Kaya Lee',
    'Andi Liu',
    'Justin Meng',
    'Shivani Puli',
    'Gregorio Florentino Sanchez',
    'Minjoo Song',
    'Katherine Sun',
    'Rohan Vasishth',
    'Kyle Wong',
    'Vincent Zhang',
  ],
};

const gamma = {
  name: 'Gamma',
  members: [
    'Arnav Agarwal',
    'Joshua Ahn',
    'Ryan Choi',
    'Rohan Deme',
    'Alexis Elliot',
    'Iris Hwang',
    'Olivia Jerdee',
    'Rachel Lee',
    'Tiffany Lee',
    'Francisco Mendes',
    'Steph Ran',
    'Mahum Sheikh',
    'Brayley Starr',
    'Je Yeong (James) Soh',
    'Boen Wang',
    'Kevin Wang',
    'Lan (Maggie) Xu',
    'Kathy Yao',
  ],
};

const delta = {
  name: 'Delta',
  members: [
    'Tanvi Bagal',
    'Matthew Chang',
    'Tiffany Cheng',
    'Grant Harris',
    'Chirag Kawediya',
    'Clarice Kim',
    'Nicholas Lee',
    'Zelia Mauro',
    'Alexa Norman',
    'Javier Portet',
    'Jonathan Roven',
    'Aafia Sait',
    'Arya Sapra',
    'Tristan Sharma',
    'Lade Tinubu',
    'David Xue',
  ],
};

const epsilon = {
  name: 'Epsilon',
  members: [
    'Spencer Dearman',
    'Erik Ely',
    'Arjun Garg',
    'Chaplin Huang',
    'Siya Kalra',
    'Mariam Katsadze',
    'Skylar Liu',
    'Ryan Lobo',
    'Catherine Lu',
    'Fatima Madey',
    'Rohan Madhogarhia',
    'Olivia Moreno',
    'Charlotte Roth',
    'Hermela Selam',
    'Ranya Sharma',
    'Mitchell Velasco',
    'George Wang',
    'Gerald Yeo',
  ],
};

const zeta = {
  name: 'Zeta',
  members: [
    'Anika Bansal',
    'Oscar Chen',
    'Kasey Corra',
    'Luca Dovichi',
    'Alan Hernandez',
    'Minseo Kim',
    'Quincy Leung',
    'Connor McGraw',
    'Jessica Ortiz',
    'Ashton Tang',
    'Helen Tian',
    'Robert Xing',
  ],
};

const eta = {
  name: 'Eta',
  members: [
    'Iris Badezet-Delory',
    'Danielle Brennan',
    'Guan Chen',
    'Hudson Chung',
    'Paulina DePaulo',
    'Nathan Delisle',
    "Ta'Naija Fair",
    'Winston Li',
    'Grace Lu',
    'Sebastien Ludwig',
    'Fredric Ngo',
    'John Rugemalila',
    'Albert Seo',
    'Kara Taylor',
    'Reilly Vejar',
    'Julie Xie',
  ],
};

const theta = {
  name: 'Theta',
  members: [
    'Anna Yan',
    'Caden Tebow',
    'Chloe Eng',
    'Clarisse Cheung',
    'Danny Willow Liu',
    'Defne Meric Erdogan',
    'Eddie Wu',
    'Elena Loucks',
    'Enzo Nakornsri',
    'Eric Wong',
    'Grace Janusz',
    'Luke Jimenez',
    'Michael Fujiyama',
    'Rhea Gupta',
    'Sabrina Chen',
    'Yunah Chung',
  ],
};

const iota = {
  name: 'Iota',
  members: [
    'Adrian Dai',
    'Nam Nguyen',
    'Maddy Tavel',
    'David Conway',
    'Yuna Otsuki',
    'Kerry Zhou',
    'Veronica Sokoloff',
    'Vibhav Singh',
    'Mia Aklufi',
    'Noah Michel',
    'Kacie Stoner',
    'Isabella Ahuactzin',
    'Shinyi Li',
    'Alissa Cheong',
    'Ryan Kotamraju',
    'Nathan Lee',
  ],
};

const kappa = {
  name: 'Kappa',
  members: [
    'Abraham Flores',
    'Aeliya Grover',
    'Brayden Miller',
    'Alex Noh',
    'Carmen de Vries',
    'Andrew Cheng',
    'Uma Malani',
    'Calvin Lai',
    'Antonia Tarfulea',
    'Elena Wang',
    'Elizabeth Zhao',
    'Eugenia Osei Bonsu',
    'Dante Vairus',
    'Nhi Nguyen',
    'Evie Hu',
    'Oliver Wang',
    'Aryan Kaushal',
  ],
};

export const CLASSES = [
  founders,
  alpha,
  beta,
  gamma,
  delta,
  epsilon,
  zeta,
  eta,
  theta,
  iota,
  kappa,
];
